<div class="details-container">

  <div class="details-header" style="background: url(assets/images/reading-sch2.jpg);">
      
    <div class="details-banner">
        <h1>Reading School | Late Transfer</h1>
        <h2>(Mid-Year 12+ and 13+) Entry Information</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h3>Introduction</h3>

    <div class="spacer"></div>

    <p>Reading School is a grammar school for boys with academy status in Berkshire. Founded as part of Reading Abbey, it is considered one of the oldest schools in the country. Its list of notable alumni includes a Former Prime Minister of the UK, a Victoria Cross recipient and an impressive number of university professors. <br> <br>
      Benefitting from a broad curriculum which spans across a number of disciplines, pupils at Reading grammar tend to surpass their academic potential and develop into articulate and proficient individuals. The programme of lessons includes art, science, Classics, computer science, humanities and MFL, among others, allowing boys to discover their strengths and minimise their weaknesses throughout their educational journey. <br> <br>
      Co-curricular activities range from chess, drama and animation to coding, Book Club and bush craft, ensuring that students learn beyond the classroom, develop practical skills and explore their passions while growing in an understanding of their own abilities. These and many other enrichment opportunities profoundly impact the learning experience at Reading grammar, making it memorable, effective and thoroughly engaged in helping boys mature both independently and responsibly. <br> <br>
      According to OFSTED, the school features an outstanding quality of education, supported by qualified staff who ensure that boys feel secure, valued and respected within the close knit community. In the report, pupils’ attitudes to learning are characterised as extremely positive, complementing the sense of purpose and the commitment to excellence that flourish both in and out of Reading School’s classrooms.</p>



    <div class="spacer"></div>

    <h2>Reading School Late Transfer (In-Year Entry) Exam Information</h2>

    <div class="spacer"></div>


    <p><strong>Address: </strong> Erleigh Road, Reading RG1 5LW</p>
    <p><strong>County:</strong> Berkshire</p>
    <p><strong>Admissions info:</strong> admissions&#64;reading-school.co.uk or 0118 9015600</p>
    <p><strong>School type:</strong> Grammar school for boys</p>
    <p><strong>Number of students: </strong> 870 (approx.)</p>
    <p><strong>Open Day date: </strong>In the Spring and Autumn terms</p>
    <p><strong>11+ Exam date: </strong> September 2025</p>
    <p><strong>Exam type / Board:</strong> CEM Select and school’s own</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Reading School In-Year Entry (12 Plus & 13 Plus) Admissions Information</h2>

    <div class="spacer"></div>

    <p>Besides its standard point of entry (11+), the school also accepts late entry applications. The Late Entry exam consists of two parts:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>Part one: CEM Select</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Part two: English comprehension</p></div>

    <p>Your child’s results in the online CEM Select assessment will be combined, standardised and placed in rank order, on the basis of which his comprehension skills will then be assessed. Results from both exams will be combined and will determine his overall rank order.</p>

    <p>Please note that the school will assess applicants only if there are places available. If there are more applications than there are places available, Reading grammar will apply their oversubscription criteria, based on which priority will be given to:</p>


    <div><img src="assets/images/check-list.png" alt=""> <p>A looked after child or previously looked after child;</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Pupil premium recipients (service premium for boarders);</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Applicants who live within the school’s designated area (for day places);</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Applicants who have a boarding need (for boarding places).</p></div>

    <div class="spacer"></div>

    <h2>Reading School Late Transfer (In-Year) Exam Format</h2>

    <div class="spacer"></div>

    <p>The CEM Select assessment will cover the following areas:</p>


    <div><img src="assets/images/check-list.png" alt=""> <p>Verbal Reasoning</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Non-Verbal Reasoning</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Numerical Reasoning</p></div>

    <p>The Verbal Reasoning section of the test assesses your child’s ability to solve problems using words, with a special focus on depth and breadth of vocabulary. <br>

      The Non-Verbal Reasoning section requires your child to solve problems using shapes and patterns with a main focus on one specific question type. <br>       
      
      The Numerical Reasoning section assesses your child’s ability to solve problems using numbers and arithmetic. <br>
      
      The English paper will examine your child’s comprehension skills through standard format questions. </p>



    <div class="spacer"></div>

    <h2>Queen Elizabeth’s School, Barnet, 11 Plus (11+) Exam Format</h2>

    <p>The 11+ entrance exam at Queen Elizabeth’s School, Barnet, consists of two multiple-choice test papers in:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>English</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Mathematics</p></div>

    <p>The Verbal Reasoning section of the test assesses your child’s ability to solve problems using words, with a special focus on depth and breadth of vocabulary. <br> <br>

      The Non-Verbal Reasoning section requires your child to solve problems using shapes and patterns with a main focus on one specific question type. <br> <br>
      
      The Numerical Reasoning section assesses your child’s ability to solve problems using numbers and arithmetic. <br> <br>
      
      The English paper will examine your child’s comprehension skills through standard format questions.</p>

    <div class="spacer"></div>


  </div>

</div>

</div>